import { ONG_CARD_STATES } from 'solidarity.module/common/domain/constants.solidarity';

class OngCardSwitchController {
  constructor($scope, EventEmitter) {
    'ngInject';
    this.scope = $scope;
    this.EventEmitter = EventEmitter;

    this._setWatchAmount();
  }

  $onInit() {
    this._initMoney();
  }

  _initMoney() {
    this.money = this.amount || this.minDonation;
  }

  _setWatchAmount() {
    this.scope.$watch(() => this.amount, () => {
      this.money = this.amount || this.minDonation;
    });
  }

  getCssMoney() {
    return {
      active: this.isInsertData(),
      'no-contribution': this.cardState === ONG_CARD_STATES.INITIAL
    };
  }

  isViewData() {
    return this.cardState === ONG_CARD_STATES.INITIAL || this.cardState === ONG_CARD_STATES.CONTRIBUTION;
  }

  isInsertData() {
    return this.cardState === ONG_CARD_STATES.ADD || this.cardState === ONG_CARD_STATES.EDIT;
  }

  goInsertData() {
    if (this.cardState === ONG_CARD_STATES.INITIAL) {
      this.onEditCardState(this.EventEmitter({ cardState: ONG_CARD_STATES.ADD }));
      return;
    }

    if (this.cardState === ONG_CARD_STATES.CONTRIBUTION) {
      this.onEditCardState(this.EventEmitter({ cardState: ONG_CARD_STATES.EDIT }));
    }
  }

  increaseMoney() {
    this.money = (this.money + 1 > this.maxDonation) ? this.maxDonation : this.money + 1;
    this.editAmount();
  }

  decreaseMoney() {
    this.money = (this.money - 1 < this.minDonation) ? this.minDonation : this.money - 1;
    this.editAmount();
  }

  onChangeMoney() {
    if (this.money > this.maxDonation) {
      this.money = this.maxDonation;
    } else if (this.money < this.minDonation) this.money = this.minDonation;

    this.editAmount();
  }

  editAmount() {
    this.onEditAmount(this.EventEmitter({ amount: this.money }));
  }
}

export default OngCardSwitchController;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongCard/ongCardSwitch/ongCardSwitch.controller.js